import * as React from 'react';
import { ETargetPage, MainFiltersWidget, Provider } from '@cian/valuation-main-filters-widget';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { useSelector } from 'react-redux';

import { selectIsFindAgentTabEnabled } from '../../selectors/featureToggles/selectIsFindAgentTabEnabled';

export const MainFiltersWidgetContainer: React.FC = () => {
  const isDesktop = useDeviceType() === 'desktop';
  const isFindAgentTabEnabled = useSelector(selectIsFindAgentTabEnabled);

  return (
    <Provider
      value={{
        isDesktop,
        targetPage: ETargetPage.valuation,
        isFindAgentTabEnabled,
      }}
    >
      <MainFiltersWidget />
    </Provider>
  );
};

MainFiltersWidgetContainer.displayName = 'MainFiltersWidgetContainer';
